import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { SharedModule } from "../shared/shared.module";
import { PlanningState } from "../shared/store/planning.state";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "application-info",
  templateUrl: "application-info.component.html",
  styleUrls: ["application-info.component.scss"],
  standalone: true,
  imports: [SharedModule, CommonModule],
})
export class ApplicationInfoComponent implements AfterViewInit {
  groupname$: Observable<string>;
  showFaq: boolean = false;
  modals = [
    {
      id: "modal-first-time",
      title: "De eerste keer werken met Groeimeter",
      image: "/assets/images/2-Startscherm.png",
    },
    {
      id: "modal-filters",
      title: "Het gebruiken van de filters",
      image: "/assets/images/Zoeken-Orientatie_planscherm.png",
    },
    {
      id: "modal-goals",
      title: "Plannen van leerdoelen",
      image: "/assets/images/3-Leerlingscherm.png",
    },
    {
      id: "modal-student-screen",
      title: "Leerlingscherm",
      image: "/assets/images/3-Leerlingscherm.png",
    },
    {
      id: "modal-results",
      title: "Bekijken van resultaten",
      image: "/assets/images/1-leerlijnscherm.png",
    },
    {
      id: "modal-profile",
      title: "Werken met profielen",
      image: "/assets/images/1-leerlijnscherm.png",
    },
    {
      id: "modal-learn-line",
      title: "Eigen leerlijn samenstellen",
      image: "/assets/images/Bewerken_leerlijn.png",
    },
  ];

  videoModals = [
    {
      id: "modal-video-dashboard",
      title: "Oriënteren: het dashboard in één oogopslag",
      video:
        "PO-Groeimeter22-spelling-01_orienteren- het dashboard in een oogopslag.mp4",
    },
    {
      id: "modal-video-list-goals",
      title: "Een lijst met alle leerdoelen samenstellen",
      video:
        "PO-Groeimeter22-spelling-02_Een lijst met alle leerdoelen samenstellen.mp4",
    },

    {
      id: "modal-video-filters",
      title: "Uitleg over de filtermogelijkheden",
      video: "PO-Groeimeter22-spelling-03_filters.mp4",
    },

    {
      id: "modal-video-profile-filters",
      title: "Profiel toekennen aan een leerling t.b.v. filters",
      video:
        "PO-Groeimeter22-spelling-04_Profiel toekennen aan leerling tbh filters.mp4",
    },

    {
      id: "modal-video-delete-goal",
      title: "Een gepland leerdoel voor een leerling verwijderen",
      video:
        "PO-Groeimeter22-spelling-05_Een gepland leerdoel voor een leerling verwijderen.mp4",
    },

    {
      id: "modal-video-plan-goal-group",
      title: "Een leerdoel inplannen voor een groep",
      video:
        "PO-Groeimeter22-spelling-06_Een leerdoel inplannen  voor een groep.mp4",
    },

    {
      id: "modal-video-delete-planned-goal",
      title: "Een gepland leerdoel voor een groep verwijderen",
      video:
        "PO-Groeimeter22-spelling-05_Een gepland leerdoel voor een leerling verwijderen.mp4",
    },

    {
      id: "modal-video-login-student",
      title: "Inloggen en uitloggen van een leerling",
      video:
        "PO-Groeimeter22-spelling-07_inloggen en uitloggen van een leerling.mp4",
    },

    {
      id: "modal-video-prepared-test-description",
      title: "Omschrijving van een toets die klaarstaat bekijken",
      video:
        "PO-Groeimeter22-Omschrijving_van_een_toets_die_klaarstaat_bekijken.mp4",
    },

    {
      id: "modal-video-start-test",
      title: "Een toets starten",
      video: "PO-Groeimeter22-spelling-08_Een toets starten.mp4",
    },

    {
      id: "modal-video-result-test",
      title: "Het resultaat van een toets bekijken",
      video:
        "PO-Groeimeter22-spelling-09_Het resultaat van een toets bekijken.mp4",
    },

    {
      id: "modal-video-student-progress",
      title: "De voortgang van een leerling bekijken",
      video: "PO-Groeimeter22-spelling-10_voortgangleerling.mp4",
    },

    {
      id: "modal-video-student-goal",
      title: "Leerdoel van een leerling op gehaald of niet gehaald zetten",
      video: "PO-Groeimeter22-spelling-11_leerdoel gehaald of niet gehaald.mp4",
    },

    {
      id: "modal-video-student-goal-replan",
      title: "Een leerdoel van een leerling opnieuw inplannen",
      video:
        "PO-Groeimeter22-spelling-12_Leerdoel van een leerling opnieuw inplannen.mp4",
    },

    {
      id: "modal-video-profile-spelling",
      title: "Werken met profielen: Spelling",
      video: "PO-Groeimeter22-spelling-17_klik op de tegel Spelling.mp4",
    },

    {
      id: "modal-video-profile-math",
      title: "Werken met profielen: Rekenen",
      video: "PO-Groeimeter22-spelling-18_Klik op de tegel Rekenen.mp4",
    },

    {
      id: "modal-video-learn-line-selection",
      title: "Een leerlijn met een selectie van leerdoelen maken",
      video:
        "PO-Groeimeter22-spelling-13_Een leerlijn met een selectie van de leerdoelen maken.mp4",
    },

    {
      id: "modal-video-learn-line-add-remove-goal",
      title: "Een leerdoel aan een leerlijn toevoegen of verwijderen",
      video:
        "PO-Groeimeter22-spelling-14_Een leerdoel aan een leerlijn toevoegen of verwijderen.mp4",
    },

    {
      id: "modal-video-learn-line-save",
      title: "Voorbeeld van een leerdoel in de leerlijn bekijken",
      video:
        "PO-Groeimeter22-spelling-15_Een voorbeeld van een leerdoel in de leerlijn bekijken.mp4",
    },

    {
      id: "modal-video-learn-line-delete",
      title: "Een leerlijn verwijderen",
      video: "PO-Groeimeter22-spelling-16_Een leerlijn verwijderen.mp4",
    },
  ];

  infoToc = [
    {
      label: "De eerste keer werken met groeimeter",
      gotoId: "scroll-to-first-time",
    },
    {
      label: "Het gebruiken van de filters",
      gotoId: "scroll-to-filters",
    },
    {
      label: "Plannen van leerdoelen",
      gotoId: "scroll-to-plan",
    },
    {
      label: "Leerlingscherm",
      gotoId: "scroll-to-student-screen",
    },
    {
      label: "Bekijken van resultaten",
      gotoId: "scroll-to-results",
    },
    {
      label: "Werken met profielen",
      gotoId: "scroll-to-profiles",
    },
    {
      label: "Eigen leerlijn samenstellen",
      gotoId: "scroll-to-create-learn-line",
    },
  ];

  faqToc = [
    {
      label: "Waar komen de leerdoelen vandaan?",
      gotoId: "scroll-to-faq-learn-goals",
    },
    {
      label: "Na het inloggen kom ik in een wit scherm, hoe kan dit?",
      gotoId: "scroll-to-faq-white-screen",
    },
    {
      label: "Kan ik een leerling een ander plaatje geven?",
      gotoId: "scroll-to-faq-change-image",
    },
    {
      label:
        "Wat gebeurt er als een leerling het toetsje afbreekt tijdens het invullen? ",
      gotoId: "scroll-to-faq-abort-test",
    },
    {
      label: "Voldoet Groeimeter aan alle kerndoelen van SLO?",
      gotoId: "scroll-to-faq-slo",
    },
    {
      label: "Kan ik zelf leerdoelen toevoegen?",
      gotoId: "scroll-to-faq-add-goals",
    },
    {
      label: "Hoe gebruik ik Groeimeter in combinatie met LVS-afnames?",
      gotoId: "scroll-to-faq-lvs",
    },
    {
      label:
        "Wat is het verschil tussen het meten van beheersing (Groeimeter) en van vaardigheid (LVS-toetsen)?",
      gotoId: "scroll-to-faq-lvs-groeimeter",
    },
    {
      label: "Op welke manieren kan ik Groeimeter inzetten?",
      gotoId: "scroll-to-faq-use-cases",
    },
    {
      label: "Is Groeimeter een reken- of een spellingmethode?",
      gotoId: "scroll-to-faq-math-spelling",
    },
    {
      label: "Kan ik in Groeimeter leerdoelen selecteren?",
      gotoId: "scroll-to-faq-select-goals",
    },
    {
      label: "Is Groeimeter webbased?",
      gotoId: "scroll-to-faq-webbased",
    },
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store,
    private domSanitizer: DomSanitizer
  ) {
    this.groupname$ = this.store.select(PlanningState.groupname);
  }
  ngAfterViewInit(): void {
    this.videoModals.forEach((videoModal) => {
      const modal = document.getElementById(videoModal.id);

      const observer = new MutationObserver((mutations, _) => {
        mutations.forEach((mutation) => {
          if (
            mutation.attributeName === "aria-hidden" &&
            (mutation.target as any).ariaHidden
          ) {
            this.pauseVideo(videoModal.id);
          }
        });
      });

      observer.observe(modal, { attributes: true });
    });
  }

  toggleFaq() {
    this.showFaq = !this.showFaq;
  }

  getModals() {
    return this.modals;
  }

  getVideoModals() {
    return this.videoModals;
  }

  getInfoToc() {
    return this.infoToc;
  }

  getFaqToc() {
    return this.faqToc;
  }

  pauseVideo(video: string) {
    const videoElement = document.getElementById(
      `modal-video-${video}`
    ) as HTMLVideoElement;
    videoElement.pause();
  }

  scrollToTocItem(id: string) {
    document.getElementById(id).scrollIntoView({ behavior: "smooth" });
  }
}
